import { useEffect } from "react";

const useLenis = () => {
  useEffect(() => {
    // Disable smooth scrolling on mobile devices for better performance
    const isMobile =
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768;

    if (isMobile) {
      return; // Skip Lenis on mobile - don't even load the libraries
    }

    // Dynamic import - only load heavy libraries on desktop
    let lenis: any;
    let cleanup: (() => void) | undefined;

    const initLenis = async () => {
      const [{ default: Lenis }, { gsap }] = await Promise.all([import("lenis"), import("gsap")]);

      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - 2 ** (-10 * t)),
        orientation: "vertical",
        gestureOrientation: "vertical",
        smoothWheel: true,
        syncTouch: false,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        infinite: false,
      });

      const onScroll = gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);

      cleanup = () => {
        gsap.ticker.remove(onScroll);
        lenis.destroy();
      };
    };

    initLenis();

    return () => {
      if (cleanup) cleanup();
    };
  }, []);
};

export default useLenis;
